export default __webpack_public_path__ + "static/media/woman_watering_plant_620x498.66183072.svg";